<template>
  <nav class="card">
    <div class="container nav-wrapper">
      <h1>Where is the world?</h1>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navbar'
}
</script>

<style lang="scss" scoped>
nav {
}
.nav-wrapper {
  padding: 1.5rem 0;
}

</style>
